export default {"src":"/_next/static/media/spotify-logo.988d8011.svg","height":2931,"width":2931,"blurWidth":0,"blurHeight":0};